import React from 'react';
import { Link } from 'react-router-dom';

const RowButton = ( {link = null, tooltip = "", disabled = false, onClick = null, color = "clear", iconclass = "icon-blocked no-text"}) => {
  
  if (disabled){
    return null;
  }

  if (link){
    return (<Link to={link} data-tip={tooltip} className={`button ${ color + ' ' + iconclass }`}/>)
  }
  
  return (
    <button data-tip={tooltip} onClick={onClick} className={`button ${ color + ' ' + iconclass }`}/>
  );
}


export default RowButton;

